import React, {Component, Fragment} from 'react';

import Button from '@material-ui/core/Button/index';
import Dialog from '@material-ui/core/Dialog/index';
import DialogActions from '@material-ui/core/DialogActions/index';
import DialogContent from '@material-ui/core/DialogContent/index';
import DialogTitle from '@material-ui/core/DialogTitle/index';
import Slide from "@material-ui/core/Slide/index";
import DraggableModal from "../../../Include/DraggableModal/DraggableModal";
import {FieldsJs} from "../../../../settings/General/General";
import PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import {ReactLocalStorageService} from "../../../../settings/ReactLocalStorageService/ReactLocalStorageService";
import {BotonAccionAbrirModal} from "../../../Include/MiniComponents/GlobalComponent";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import {FacturacionService} from "../../../../services/FacturacionService/FacturacionService";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import {Description, Folder} from "@material-ui/icons";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import {CONFIG} from "../../../../settings/Config/Config";
import ListItemText from "@material-ui/core/ListItemText";
import Typography from "@material-ui/core/Typography";

class ModalEstatusSat extends Component {
	
	state = {};
	
	Usr = {};
	
	showSnackBars = this.props.showSnackBars;
	RefreshList = this.props.RefreshList;
	
	constructor(props) {
		super(props);
		
		
		this.Usr = ReactLocalStorageService.get('Usr') || {};
		
		this.state = {
			modal: {
				open: false
			},
			tipo: props.tipo,
			
			id_facturacion_archivo: (props.item || '').id_facturacion_archivo,
			id_facturacion: (props.item || '').id_facturacion,
			id_cat_facturacion_status_sat: '',
			observacion: '',
			
			lista_obsercacion_cancelacion: (props.item || []).cancelaciones
		};
	}
	
	handleChange = (e, variable, campo, date, input) => {
		FieldsJs.HandleChange(e, variable, campo, date, input, (r) => this.setState({
			[r.name]: r.value
		}));
	};
	
	changeValue = (arr_name__key, var_name, var_value) => {
		FieldsJs.ChangeValue(arr_name__key, var_name, var_value, (r) => this.setState({
			[r.name]: r.value
		}), this.state);
	};
	
	openModal = () => {
		const props = this.props;
		this.setState({
			modal: {
				open: true
			},
		});
	};
	
	closeModal = () => {
		this.setState({
			modal: {
				open: false
			}
		});
	};
	
	open = () => {
		this.init().then(r => {
			setTimeout(() => this.openModal());
		}).catch(e => {
		});
	};
	
	close = () => {
		this.closeModal();
	};
	
	init = () => {
		return new Promise((resolve) => {
			resolve(true);
		});
	};
	
	
	add = () => {
		const {item} = this.props;
		this.setState({
			id_facturacion: item.id_facturacion,
			id_facturacion_archivo: item.id_facturacion_archivo,
			id_cat_facturacion_status_sat: '',
			observacion: '',
		});
		
		this.open();
		
	};
	
	
	is_view = () => {
		return this.props.tipo === 'view';
	};
	
	is_edit = () => {
		return this.props.tipo === 'edit';
	};
	
	is_add = () => {
		return this.props.tipo === 'add';
	};
	
	is_edited_product = () => {
		return this.state.key !== null && this.state.key > -1;
	};
	
	is_root = () => {
		return FieldsJs.inArray([1], this.Usr.id_cat_tipo_usuario);
	};
	
	
	save = () => {
		try {
			
			if (FieldsJs.inArray([2, 9], this.state.id_cat_facturacion_status_sat) && this.Usr.id_cat_tipo_usuario !== 4) {
				if (!FieldsJs.Field(this.state.observacion)) {
					throw Object({
						status: false, mensaje: 'El campo observación es requerido.'
					})
				}
			}
			
			FacturacionService.StatusSat(this.state).then((response) => {
				this.closeModal();
				this.props.RefreshList();
				this.props.showSnackBars('success', response.mensaje);
			}).catch((error) => {
				this.props.showSnackBars('error', error.mensaje);
			});
			
		} catch (e) {
			this.props.showSnackBars('error', e.mensaje);
		}
	};
	
	render() {
		
		let funcion;
		
		switch (this.state.tipo) {
			case 'edit':
				funcion = this.edit;
				break;
			case 'add':
				funcion = this.add;
				break;
			/*case 'view':
				funcion = this.view;
				break;*/
			default:
				funcion = () => {
				};
		}
		
		
		return (
			<div>
				
				{this.props.componente ? (
					<Fragment>
						<span
							style={{cursor: 'pointer'}}
							children={this.props.componente}
							onClick={() => funcion()}
						/>
					</Fragment>
				) : (
					<BotonAccionAbrirModal
						id={this.state.id_facturacion_archivo}
						tipo={this.state.tipo}
						onClick={() => funcion()}
					/>
				)}
				
				<Dialog open={this.state.modal.open} onClose={() => this.close()} PaperComponent={DraggableModal}
				        disableEscapeKeyDown disableBackdropClick maxWidth={'sm'} fullWidth={true} scroll={'paper'}
				        transition={<Slide direction="up"/>} aria-labelledby="scroll-dialog-title"
				>
					
					<DialogTitle>
						Estatus Sat
					</DialogTitle>
					
					<DialogContent>
						
						<Grid container spacing={0} alignItems={"flex-end"} alignContent={"flex-end"}>
							
							{/*<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
								<Typography className={'margin-15-B'} style={{color: 'gray', opacity: '0.8'}}>
									Seleccionar opción:
								</Typography>
							</Grid>*/}
							
							<Grid item className={'text-left'} xs={12} sm={12} md={12} lg={12} xl={12}>
								<RadioGroup row aria-label="position" name="id_cat_facturacion_status_sat"
								            value={this.state.id_cat_facturacion_status_sat.toString()}
								            onChange={this.handleChange}
								>
									{Number(this.Usr.id_cat_tipo_usuario) !== 9 ? (
										<FormControlLabel
											labelPlacement="end"
											control={<Radio color="primary"/>}
											value={'1'}
											label="Vigente"
											disabled={this.props.tipo === 'view'}
										/>
									) : null
									}
									<FormControlLabel
										labelPlacement="end"
										control={<Radio color="primary"/>}
										value={'2'}
										label="Cancelado"
										disabled={this.props.tipo === 'view'}
									/>
									{Number(this.Usr.id_cat_tipo_usuario) === 9 ? (
										<FormControlLabel
											labelPlacement="end"
											control={<Radio color="primary"/>}
											value={'9'}
											label="No es posible cancelar"
											disabled={this.props.tipo === 'view'}
										/>
									) : null
									}
								</RadioGroup>
							</Grid>
							
							{FieldsJs.inArray([2, 9], this.state.id_cat_facturacion_status_sat) && this.Usr.id_cat_tipo_usuario !== 4 ? (
								<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
									<TextField
										rows={2}
										multiline
										margin="none"
										name="observacion"
										label="Observación"
										type="text"
										fullWidth
										value={this.state.observacion}
										onChange={this.handleChange}
										required
									/>
								</Grid>
							) : null
							}
						</Grid>
						
						<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
							<div>
								{this.state.lista_obsercacion_cancelacion.map((item, key) => (
									<Fragment key={key}>
										<ListItem>
											<ListItemAvatar>
												<Avatar
													alt={item.nombre_completo}
													src={item.foto ? CONFIG.src + item.foto : CONFIG.foto_default}
													className={'margin-0'}
													style={{
														height: '35px',
														width: '35px',
														marginTop: '2px',
														textAlign: 'left',
													}}
												/>
											</ListItemAvatar>
											
											<ListItemText
												style={{
													fontSize: '12px !important',
													margin: 0,
													padding: '2px 5px',
													borderRadius: 6,
													textAlign: 'left',
													backgroundColor: 'rgba(236,236,236,0.59)'
												}}
												primary={<Typography type="body2" style={{fontSize: '11px', margin: 0, padding: 0}}>
													{item.nombre_completo}</Typography>}
												secondary={
													<Fragment>
														<Typography
															component="span"
															variant="body2"
															color="textPrimary"
															style={{fontSize: '11px'}}
														>
															Observación:
														</Typography>
														{" — " + item.observacion}
													</Fragment>
												}
											/>
										</ListItem>
									</Fragment>
								))}
							</div>
							
						</Grid>
					
					</DialogContent>
					
					<DialogActions>
						<Grid container spacing={2}>
							<Grid item xs={6} align={'left'}>
								<Button onClick={() => this.close()} color="primary">
									Cancelar
								</Button>
							</Grid>
							<Grid item xs={6} align={'right'}>
								{!this.is_view() ? (
									<Button onClick={() => this.save()} color="primary">
										{'Guardar'}
									</Button>
								) : null}
							</Grid>
						</Grid>
					</DialogActions>
				
				</Dialog>
			
			</div>
		);
	}
}

ModalEstatusSat.propTypes = {
	item: PropTypes.object.isRequired,
	tipo: PropTypes.oneOfType([
		PropTypes.string.isRequired,
		PropTypes.oneOf(['view', 'add', 'edit']).isRequired,
	]),
	componente: PropTypes.element,
	showSnackBars: PropTypes.func.isRequired,
	RefreshList: PropTypes.func.isRequired,
};

export default ModalEstatusSat;
